
import link from './file-change.link';

export default function fileChange () {
	return {
		restrict:'A',
		link
	};
};

fileChange.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/file-change/file-change.js